import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { FeeType } from '../../../types';

interface QuickOrderAddAdditionalFeeDialogProps {
	open: boolean;
	onClose: () => void;
	onSubmit: (name: string, price: number, feeType: FeeType) => void;
}

export const QuickOrderAddAdditionalFeeDialog = ({ open, onClose, onSubmit }: QuickOrderAddAdditionalFeeDialogProps) => {
	const [name, setName] = useState('');
	const [price, setPrice] = useState('');
	const [feeType, setFeeType] = useState(FeeType.Fixed);

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		onSubmit(name, Number(price), feeType);
		setName('');
		setPrice('');
		setFeeType(FeeType.Fixed);
		onClose();
	};

	return (
		<Dialog open={open} onClose={onClose}>
			<form onSubmit={handleSubmit}>
				<DialogTitle>Add Additional Fee</DialogTitle>
				<DialogContent>
					<TextField
						autoFocus
						autoComplete='off'
						margin="dense"
						label="Name"
						fullWidth
						value={name}
						onChange={(e) => setName(e.target.value)}
						required
					/>
					<TextField
						margin="dense"
						autoComplete='off'
						label="Price"
						type="number"
						fullWidth
						value={price}
						onChange={(e) => setPrice(e.target.value)}
						required
					/>
					<FormControl
						margin="dense"
						fullWidth
						variant='outlined'
					>
						<InputLabel>Type</InputLabel>
						<Select
							margin="dense"
							label="Type"
							fullWidth
							value={feeType}
							onChange={(e) => setFeeType(e.target.value as FeeType)}
						>
							<MenuItem value={FeeType.Percentage}>Percentage</MenuItem>
							<MenuItem value={FeeType.Fixed}>Fixed</MenuItem>
						</Select>
					</FormControl>
				</DialogContent>
				<DialogActions>
					<Button onClick={onClose}>Cancel</Button>
					<Button type="submit" variant="contained">Add Fee</Button>
				</DialogActions>
			</form>
		</Dialog>
	);
}; 